import { jsxs as m, Fragment as w, jsx as o } from "react/jsx-runtime";
import { QUERIES as b } from "@fcamna/shared-component-foundations";
import { c as W } from "./index-65016bfa.mjs";
import f, { useMemo as G } from "react";
import A, { css as c, styled as B } from "styled-components";
import { u as z } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { c as d } from "./cloneSlots-333ddef1.mjs";
import { b as $ } from "./useSlots-a1aa6a84.mjs";
import { Button as S } from "./button.js";
import { Disclosures as j } from "./disclosure.js";
import { Icon as T } from "./icon.js";
import { Link as y } from "./link.js";
import { Tag as _, TagsGroup as h } from "./tags.js";
import { c as E } from "./childrenCountCheck-785fa19a.mjs";
import { h as L } from "./hTag-27bb1617.mjs";
import { Text as V } from "./text.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "@fcamna/shared-icons";
import "./Aria-f5e019e2.mjs";
import "./closeButton.js";
import "./iconButton.js";
const H = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, R = A.span`
  &.GlobalAttributeBar__title {
    ${({
  theme: {
    components: { globalAttributeBar: t }
  }
}) => c(t.TitleWrapper)};
  }
`, M = A(L)`
  &.GlobalAttributeBar__value {
    ${({
  theme: {
    components: { globalAttributeBar: t }
  }
}) => c(t.ValueWrapper)};
  }
`, F = A.span`
  &.GlobalAttributeBar__description_container {
    ${({
  theme: {
    components: { globalAttributeBar: t }
  }
}) => c(t.DescriptionContainer)};
  }
`, Q = A(V.P)`
  ${H()}
  &.GlobalAttributeBar__description_wrapper {
    ${({
  theme: {
    components: { globalAttributeBar: t }
  }
}) => c(t.DescriptionWrapper)};
  }
`, q = 5, X = B.div`
  ${({ theme: { componentStyles: t } }) => c(t)};
  background-color: ${(t) => t.theme.components.globalAttributeBar.GlobalWrapper.backgroundColor};
  display: ${(t) => t.theme.components.globalAttributeBar.GlobalWrapper.display};
  flex-direction: ${(t) => t.theme.components.globalAttributeBar.GlobalWrapper.flexDirection};
  border: ${(t) => t.theme.components.globalAttributeBar.GlobalWrapper.border};
  box-sizing: ${(t) => t.theme.components.globalAttributeBar.GlobalWrapper.boxSizing};

  @media ${b.laptopAndUp} {
    flex-direction: ${(t) => t.theme.components.globalAttributeBar.GlobalWrapper.laptopAndUp.flexDirection};
    min-height: ${(t) => t.theme.components.globalAttributeBar.GlobalWrapper.laptopAndUp.minHeight};
  }
  @media ${b.desktopAndUp} {
    min-height: ${(t) => t.theme.components.globalAttributeBar.GlobalWrapper.desktopAndUp.minHeight};
  }
`, J = B.div`
  padding: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.padding};
  display: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.display};
  align-items: ${({ $enableButton: t, ...r }) => t ? r.theme.components.globalAttributeBar.ItemWrapper.alignItems.enableButton : r.theme.components.globalAttributeBar.ItemWrapper.alignItems.default};
  justify-content: ${({ $enableButton: t, ...r }) => t ? r.theme.components.globalAttributeBar.ItemWrapper.justifyContent.enableButton : r.theme.components.globalAttributeBar.ItemWrapper.justifyContent.default};
  flex-direction: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.flexDirection};
  &:not(:first-child) {
    border-top: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.borderTop};
  }
  word-break: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.wordBreak};
  @media ${b.laptopAndUp} {
    width: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.laptopAndUp.width};
    padding: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.laptopAndUp.padding};
    &:not(:first-child) {
      border-top: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.laptopAndUp.borderTop};
      border-left: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.laptopAndUp.borderLeft};
    }
  }
  @media ${b.desktopAndUp} {
    padding: ${(t) => t.theme.components.globalAttributeBar.ItemWrapper.desktopAndUp.padding};
  }
`, x = B.div`
  display: ${(t) => t.theme.components.globalAttributeBar.ItemInnerWrapper.display};
  align-items: ${(t) => t.theme.components.globalAttributeBar.ItemInnerWrapper.alignItems};
  flex-direction: ${(t) => t.theme.components.globalAttributeBar.ItemInnerWrapper.flexDirection};
  gap: ${(t) => t.theme.components.globalAttributeBar.ItemInnerWrapper.gap};
  width: ${(t) => t.theme.components.globalAttributeBar.ItemInnerWrapper.width};
  && > a {
    font-family: ${(t) => t.theme.components.globalAttributeBar.ItemInnerWrapper.a.fontFamily};
    font-size: ${(t) => t.theme.components.globalAttributeBar.ItemInnerWrapper.a.fontSize};
    font-weight: ${(t) => t.theme.components.globalAttributeBar.ItemInnerWrapper.a.fontWeight};
    line-height: ${(t) => t.theme.components.globalAttributeBar.ItemInnerWrapper.a.lineHeight};
  }
`, K = B(x)`
  @media ${b.laptopAndUp} {
    gap: ${(t) => t.theme.components.globalAttributeBar.ItemDataWrapper.laptopAndUp.gap};
  }
`, O = ({ children: t }) => {
  const r = z({ label: "Global Attributes Bar" }), l = () => f.Children.map(t, (p, e) => p && f.isValidElement(p) && p.type === n ? f.cloneElement(p, {
    key: e
  }) : null);
  return /* @__PURE__ */ m(w, { children: [
    E({
      children: t,
      componentName: "GlobalAttributeBar",
      maxChildren: q
    }),
    /* @__PURE__ */ m(X, { ...r, children: [
      " ",
      l()
    ] })
  ] });
}, n = ({ children: t, enableButton: r, onClick: l, buttonLabel: p = "Button", disclosures: e }) => {
  const a = $(t, {
    title: C,
    value: k,
    description: s,
    tags: _,
    tagGroup: h,
    link: y
  }), { tags: D, description: N } = G(() => {
    const g = d(a.tags, (i, v) => /* @__PURE__ */ o(
      _,
      {
        ...i,
        className: W(["GlobalAttributeBar__Tag", i.className])
      },
      v
    )), I = d(a.tagGroup.at(-1), (i) => /* @__PURE__ */ o(
      h,
      {
        ...i,
        className: W(["GlobalAttributeBar__TagGroup", i.className]),
        _maxTagCount: 5
      }
    )), U = d(a.description.at(-1), ({ children: i }) => /* @__PURE__ */ o(s, { children: i }));
    let u;
    return g.length > 1 && !I ? u = /* @__PURE__ */ o(
      h,
      {
        className: "GlobalAttributeBar__TagGroup",
        visibleTags: 5,
        _maxTagCount: 5,
        children: g
      }
    ) : g.length === 1 && !I ? u = g : u = I, {
      tags: u,
      description: U
    };
  }, [a]);
  return /* @__PURE__ */ o(J, { $enableButton: r, children: r ? /* @__PURE__ */ o(
    S,
    {
      size: "small",
      variant: "solid",
      onClick: l,
      children: p
    }
  ) : /* @__PURE__ */ m(x, { children: [
    D,
    (a.title || a.value) && /* @__PURE__ */ m(K, { children: [
      a.title,
      a.value
    ] }),
    N,
    a.link,
    e && /* @__PURE__ */ o(
      j,
      {
        disclosureContent: e == null ? void 0 : e.disclosureContent,
        id: e == null ? void 0 : e.id,
        className: e == null ? void 0 : e.className,
        disclosureTitleColor: e == null ? void 0 : e.disclosureTitleColor,
        style: e == null ? void 0 : e.style
      }
    )
  ] }) });
}, C = ({ children: t }) => /* @__PURE__ */ o(R, { className: "GlobalAttributeBar__title", children: t }), k = ({ children: t, headingLevel: r = "h2" }) => /* @__PURE__ */ o(
  M,
  {
    className: "GlobalAttributeBar__value",
    as: r,
    children: t
  }
), s = ({ children: t }) => {
  const r = $(t, { icon: s.Icon }, $.PickType.LAST), { icons: l } = G(() => ({ icons: d(r.icon, (e, a) => /* @__PURE__ */ o(
    T,
    {
      ...e,
      size: "xxs",
      className: W(["GlobalAttributeBar__Icon", e.className])
    },
    a
  )) }), [r.icon]);
  return /* @__PURE__ */ m(F, { className: "GlobalAttributeBar__description_container", children: [
    l,
    /* @__PURE__ */ o(
      Q,
      {
        className: "GlobalAttributeBar__description_wrapper",
        size: "small",
        children: r.rest
      }
    )
  ] });
};
O.ItemContainer = n;
n.Tag = _;
n.TagGroup = h;
n.Title = C;
n.Description = s;
s.Icon = T;
n.Value = k;
n.Link = y;
export {
  O as GlobalAttributeBar
};
